// components/RefetchButton.tsx
import { Button } from 'react-bootstrap';

interface RefetchButtonProps {
  onRefetch: () => void;
  isLoading: boolean;
}

export const RefetchButton = ({ onRefetch, isLoading }: RefetchButtonProps) => {
  return (
    <Button className="btn-habi" onClick={onRefetch} disabled={isLoading}>
      {isLoading ? 'Actualizando...' : 'Actualizar'}
    </Button>
  );
};
